import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {Link} from 'react-router-dom'
import {useBreadcrumbs} from '#hooks/useBreadcrumbs'

function Breadcrumbs({pathname}) {
  const breadcrumbs = useBreadcrumbs(pathname)
  return (
    <div className="menu__breadcrumbs">
      {breadcrumbs.map(item => (
        <Link key={item.menuItemId} to={item.menuItemId} className="menu__breadcrumbs__item">
          {i18n.t(item.title)}
        </Link>
      ))}
    </div>
  )
}

Breadcrumbs.propTypes = {
  pathname: PropTypes.string.isRequired,
}

export default Breadcrumbs
